import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/rehome/get-rehome-outcome-forms';

  return API({ endpoint });
}
